import React, { memo } from "react";
import fp from "lodash/fp";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput, Tooltip } from "components";
import { ACHProcessorData as ach } from "globalConstants";
import { maxLength10, maxLength1000, required } from "validators";

import { ReactComponent as InfoIcon } from "static/images/info-round.svg";
import styles from "./../formSections.module.scss";

const StatementSection = ({ isRequired }) => (
	<>
		<Row>
			<Col>
				<div className={`${styles.subHeader} mb-4 d-flex`}>
					{ach.StatementSetup.displayName}
					<div className={styles.labelIcon}>
						<Tooltip
							html={
								<div className={styles.labelTitleWrapper}>
									{ach.StatementSetup.tooltip}
								</div>
							}
						>
							<InfoIcon />
						</Tooltip>
					</div>
				</div>
			</Col>
		</Row>
		<Row>
			<Col md={5}>
				<Field
					component={CustomInput}
					validate={fp.compact([
						isRequired ? required : undefined,
						maxLength10,
					])}
					label={ach.StatementDescriptor.displayName}
					labelIcon={<InfoIcon />}
					labelIconTooltip={ach.StatementDescriptor.tooltip}
					name={ach.StatementDescriptor.name}
					id={ach.StatementDescriptor.name}
					placeholder=""
				/>
			</Col>
		</Row>
		<Row>
			<Col>
				<Field
					component={CustomInput}
					validate={fp.compact([
						isRequired ? required : undefined,
						maxLength1000,
					])}
					labelIcon={<InfoIcon />}
					labelIconTooltip={
						ach.UseOfPaymentServiceDescription.tooltip
					}
					label={ach.UseOfPaymentServiceDescription.displayName}
					name={ach.UseOfPaymentServiceDescription.name}
					id={ach.UseOfPaymentServiceDescription.name}
					placeholder=""
					as="textarea"
					smLabel={12}
					smSelect={12}
				/>
			</Col>
		</Row>
		<hr className="line mt-2" />
	</>
);

export default memo(StatementSection);
